var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{class:['reset', { 'reset--adaptive': _vm.adaptive }],attrs:{"title":"Сбросить"},on:{"click":function($event){return _vm.$emit('click', $event)}}},[_c('i',{staticClass:"reset__icon"})])}
var staticRenderFns = []

export { render, staticRenderFns }